var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var StyledCard = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  padding: ", "px;\n  border-radius: ", "px;\n  background: #fff;\n  box-shadow: 0 0 1px 1px #eaeaea;\n"], ["\n  box-sizing: border-box;\n  padding: ", "px;\n  border-radius: ", "px;\n  background: #fff;\n  box-shadow: 0 0 1px 1px #eaeaea;\n"])), function (props) { return props.theme.spacing * 4; }, function (props) { return props.theme.borderRadius; });
export default (function (props) {
    return _jsx(StyledCard, { children: props.children });
});
var templateObject_1;
//# sourceMappingURL=index.js.map